module.exports = __webpack_public_path__ + "img/option_icon.10000d40.svg";